/* eslint-disable no-console */
import config, {CRITEO, GOOGLE_ADS} from './config.js'

export const onLoadCriteoScript = () => {
  const {
    [CRITEO]: {CRITEO_ATTRIBUTION_REGEX, CRITEO_ATTRIBUTION_SESSION_KEY}
  } = config

  const searchParams = window.location.search
  const isCriteo = new RegExp(CRITEO_ATTRIBUTION_REGEX).test(searchParams)

  // This sessionStorage key is stored to persist the attribution to criteo during session
  if (isCriteo) sessionStorage[CRITEO_ATTRIBUTION_SESSION_KEY] = true

  console.log('Criteo script has been loaded')
}

export const onLoadGoogleAdsScript = () => {
  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', config[GOOGLE_ADS].CONVERSION_ID, {
    send_page_view: false
  })

  console.log('Google Ads (gtag) script has been loaded')
}

export const onLoadRtbHouseScript = () => {
  ;(function (w, d, dn, t) {
    w[dn] = w[dn] || []
    w[dn].push({eventType: 'init', value: t, dc: ''})
    const f = d.getElementsByTagName('script')[0]
    const c = d.createElement('script')
    c.async = true
    c.src = 'https://tags.creativecdn.com/i87bcT6BOOlj1IGYN66P.js'
    f.parentNode.insertBefore(c, f)
  })(window, document, 'rtbhEvents', 'i87bcT6BOOlj1IGYN66P')

  console.log('RTB House script has been loaded')
}
